import { render } from "./ShareholderOnboard.vue?vue&type=template&id=6dcbf8f8&scoped=true&ts=true"
import script from "./ShareholderOnboard.vue?vue&type=script&lang=ts"
export * from "./ShareholderOnboard.vue?vue&type=script&lang=ts"

import "./ShareholderOnboard.vue?vue&type=style&index=0&id=6dcbf8f8&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcbf8f8"]])

export default __exports__